module.exports = __webpack_public_path__ + "static/media/icon-enginetype.e16669a5.svg";